/** Izveštaj koji se otvara kad adresa nema (ili ima neispravan) ?r= na računaru. */
export const DEFAULT_COMPANY_SCREEN = "meals";
export const DEFAULT_GROUP_COMPANY_SCREEN = "groupUsers";
export const DEFAULT_CANTEEN_SCREEN = "employees";
export const DEFAULT_MULTI_SCREEN = "meals";

/** Firma sa ugovorom "više restorana" (contract 4): izveštaji po restoranima firme i krediti radnika. */
export const MULTI_RESTAURANT_CONTRACT = 4;

/** Obična firma, firma tipa "grupa" (jela iz grupa) ili firma "više restorana": svaka ima svoj skup izveštaja. */
export const companyVariant = (company) => {
  if (company && company.contract === MULTI_RESTAURANT_CONTRACT) {
    return "multi";
  }
  return company && company.type === "group" ? "group" : "plain";
};

/** Stranica "Izveštaj kantina" (/naplata/izvestaj-naplata) ima samo Radnike i Preuzete obroke: varijanta "canteen". */
export const defaultCompanyScreen = (variant) => {
  if (variant === "group") {
    return DEFAULT_GROUP_COMPANY_SCREEN;
  }
  if (variant === "multi") {
    return DEFAULT_MULTI_SCREEN;
  }
  return variant === "canteen" ? DEFAULT_CANTEEN_SCREEN : DEFAULT_COMPANY_SCREEN;
};

/** Grupe izveštaja firme (telefon i računar): [{ key, title, items: [ključevi izveštaja] }] */
export const buildCompanyMenu = (t, variant = "plain") => {
  if (variant === "group") {
    return [
      { key: "orders", title: t("report_mobile.groups.orders"), items: ["groupUsers", "groupOrdered", "groupOrderers"] },
      { key: "kitchen", title: t("report_mobile.groups.kitchen"), items: ["groupGrouped"] },
    ];
  }
  if (variant === "multi") {
    return [
      { key: "kitchen", title: t("report_mobile.groups.kitchen"), items: ["meals", "restaurantMeals"] },
      { key: "handout", title: t("report_mobile.groups.handout"), items: ["packing"] },
      { key: "orders", title: t("report_mobile.groups.orders"), items: ["employees", "employeeMealSummary", "restaurantSummary"] },
      { key: "credits", title: t("credits"), items: ["creditUsers", "addCredit", "creditTopups"] },
    ];
  }
  if (variant === "canteen") {
    return [
      { key: "orders", title: t("report_mobile.groups.orders"), items: ["employees"] },
      { key: "handout", title: t("report_mobile.groups.handout"), items: ["takenMeals"] },
    ];
  }
  return [
    { key: "orders", title: t("report_mobile.groups.orders"), items: ["meals", "mealEmployees", "employees", "ordered", "reserved"] },
    { key: "handout", title: t("report_mobile.groups.handout"), items: ["takenMeals", "taken", "takenCompany"] },
  ];
};
